<template>
  <v-col>
    <v-text-field
      clearable
      append-icon="search"
      width="40px"
      :autofocus="true"
      :placeholder="resx.messages.searchContractorPlaceholder"
      v-model="value.text"
    >
    </v-text-field>
  </v-col>
</template>

<script>
"use strict";

export default {
  name: "searchContractorFilters",
  props: {
    value: { type: Object }
  }
};
</script>
